export default "__VITE_ASSET__D8E9he4P__"